import auth from "../../middlewares/auth";
export const learningVideosRoute = [
  {
    path: '/unit/learning-video/list',
    component: () => import(/* webpackChunkName: "unit_management" */ '../../views/unit_management/learning_video/LearningVideoList'),
    name: 'unit_learning_video_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/unit/learning-video/add',
    component: () => import(/* webpackChunkName: "unit_management" */ '../../views/unit_management/learning_video/LearningVideoForm'),
    name: 'unit_learning_video_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/unit/learning-video/edit/:id',
    component: () => import(/* webpackChunkName: "unit_management" */ '../../views/unit_management/learning_video/LearningVideoForm'),
    name: 'unit_learning_video_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];